import type { Resolution } from "../shared/types";

export type { Resolution };

export const RESOLUTION_OPTIONS = {
  as_measured: {
    units: [],
    label: "As Measured",
    dateFormat: "yyyy-MM-dd HH:mm:ss",
  },
  hourly: {
    units: [
      ["minute", [1, 5, 15, 30]],
      ["hour", [1, 3, 6, 12]],
      ["day", [1]],
      ["week", [1]],
      ["month", [1]],
    ],
    label: "Hourly",
    dateFormat: "yyyy-MM-dd HH:mm",
  },
  daily: {
    units: [
      ["day", [1]],
      ["week", [1]],
      ["month", [1, 3, 6]],
      ["year", [1]],
    ],
    label: "Daily",
    dateFormat: "yyyy-MM-dd",
  },
} as const satisfies Record<
  Resolution,
  { units: readonly (readonly [string, readonly number[]])[]; label: string; dateFormat: string }
>;

// Helper function to get data grouping units
export const getDataGroupingUnits = (resolution: Resolution) => {
  return RESOLUTION_OPTIONS[resolution].units;
};

// Helper function to get date format
export const getDateFormat = (resolution: Resolution) => {
  return RESOLUTION_OPTIONS[resolution].dateFormat;
};
